import { ApdmCampaignDefinition } from '@euler/model/apdm';
import { useEffect, useState } from 'react';
import { Switch, Text, View } from 'react-native';
import { useTheme } from 'styled-components';
import { ReviewField } from '../../imports/ReviewControls';
export interface WizardFormProps {
  draft: ApdmCampaignDefinition;
  disabled: boolean;
  onChange: (draft: ApdmCampaignDefinition) => void;
}
export function WizardToggle({
  label,
  value,
  onChange,
  disabled = false,
}: {
  label: string;
  value: boolean;
  onChange: (value: boolean) => void;
  disabled?: boolean;
}) {
  const theme = useTheme();
  return (
    <View
      style={{
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: 12,
      }}
    >
      <Text style={{ color: theme.label.color, flex: 1, marginRight: 12 }}>
        {label}
      </Text>
      <Switch
        accessibilityLabel={label}
        value={value}
        onValueChange={onChange}
        disabled={disabled}
      />
    </View>
  );
}
export function WizardNumberField({
  label,
  value,
  onChange,
  disabled = false,
}: {
  label: string;
  value: number;
  onChange: (value: number) => void;
  disabled?: boolean;
}) {
  const [text, setText] = useState(String(value));
  useEffect(() => {
    if (Number.isFinite(value)) setText(String(value));
  }, [value]);
  return (
    <ReviewField
      label={label}
      value={text}
      disabled={disabled}
      onChange={next => {
        setText(next);
        onChange(/^\d+$/.test(next) ? Number(next) : NaN);
      }}
    />
  );
}
